import { render } from "./LoadingView.vue?vue&type=template&id=073b3d53&scoped=true"
import script from "./LoadingView.vue?vue&type=script&lang=js"
export * from "./LoadingView.vue?vue&type=script&lang=js"

import "./LoadingView.vue?vue&type=style&index=0&id=073b3d53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073b3d53"]])

export default __exports__